import { CHILDREN_TYPE } from '@/constants/text'

export default {
  methods: {
    getMemberChildPrice(childrenType, childrenPriceTable) {
      if (!Array.isArray(childrenPriceTable)) {
        childrenPriceTable = []
      }
      let childDiv = []
      switch(childrenType) {
      case 'a':
      case '10':
      case 'childrenType10':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '10')
        return childDiv.length ? (childDiv[0].price ? childDiv[0].price : 0) : 0
      case 'b':
      case '15':
      case 'childrenType15':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '15')
        return childDiv.length ? (childDiv[0].price ? childDiv[0].price : 0) : 0
      case 'c':
      case '20':
      case 'childrenType20':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '20')
        return childDiv.length ? (childDiv[0].price ? childDiv[0].price : 0) : 0
      case 'd':
      case '30':
      case 'childrenType30':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '30')
        return childDiv.length ? (childDiv[0].price ? childDiv[0].price : 0) : 0
      case 'e':
      case '40':
      case 'childrenType40':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '40')
        return childDiv.length ? (childDiv[0].price ? childDiv[0].price : 0) : 0
      case 'f':
      case '50':
      case 'childrenType50':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '50')
        return childDiv.length ? (childDiv[0].price ? childDiv[0].price : 0) : 0
      default:
        return 0
      }
    },
    getVisitorChildPrice(childrenType, childrenPriceTable) {
      if (!Array.isArray(childrenPriceTable)) {
        childrenPriceTable = []
      }
      let childDiv = []
      switch(childrenType) {
      case 'a':
      case '10':
      case 'childrenType10':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '10')
        return childDiv.length ? (childDiv[0].childPrice ? childDiv[0].childPrice : 0) : 0
      case 'b':
      case '15':
      case 'childrenType15':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '15')
        return childDiv.length ? (childDiv[0].childPrice ? childDiv[0].childPrice : 0) : 0
      case 'c':
      case '20':
      case 'childrenType20':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '20')
        return childDiv.length ? (childDiv[0].childPrice ? childDiv[0].childPrice : 0) : 0
      case 'd':
      case '30':
      case 'childrenType30':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '30')
        return childDiv.length ? (childDiv[0].childPrice ? childDiv[0].childPrice : 0) : 0
      case 'e':
      case '40':
      case 'childrenType40':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '40')
        return childDiv.length ? (childDiv[0].childPrice ? childDiv[0].childPrice : 0) : 0
      case 'f':
      case '50':
      case 'childrenType50':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '50')
        return childDiv.length ? (childDiv[0].childPrice ? childDiv[0].childPrice : 0) : 0
      default:
        return 0
      }
    },
    getBoneSbsidChildPrice(childrenType, childrenPriceTable) {
      if (!Array.isArray(childrenPriceTable)) {
        childrenPriceTable = []
      }
      let childDiv = []
      switch(childrenType) {
      case 'a':
      case '10':
      case 'childrenType10':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '10')
        return childDiv.length ? (childDiv[0].boneSubsidy ? childDiv[0].boneSubsidy : 0) : 0
      case 'b':
      case '15':
      case 'childrenType15':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '15')
        return childDiv.length ? (childDiv[0].boneSubsidy ? childDiv[0].boneSubsidy : 0) : 0
      case 'c':
      case '20':
      case 'childrenType20':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '20')
        return childDiv.length ? (childDiv[0].boneSubsidy ? childDiv[0].boneSubsidy : 0) : 0
      case 'd':
      case '30':
      case 'childrenType30':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '30')
        return childDiv.length ? (childDiv[0].boneSubsidy ? childDiv[0].boneSubsidy : 0) : 0
      case 'e':
      case '40':
      case 'childrenType40':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '40')
        return childDiv.length ? (childDiv[0].boneSubsidy ? childDiv[0].boneSubsidy : 0) : 0
      case 'f':
      case '50':
      case 'childrenType50':
        childDiv = childrenPriceTable.filter(e => e.childDiv === '50')
        return childDiv.length ? (childDiv[0].boneSubsidy ? childDiv[0].boneSubsidy : 0) : 0
      default:
        return 0
      }
    },
    getMinRoomStock(selectedDays = []) {
      let minRoomStock = null
      selectedDays.map(e => e.stock).forEach(stock => {
        // stock = 0, còn nhiều hơn bằng 10 phòng
        if (stock !== 0 && stock !== '0') {
          if (stock !== null && (minRoomStock === null || minRoomStock > stock)) {
            minRoomStock = stock
          } else if (stock === null) {
            minRoomStock = 0
          }
        }
      })
      return minRoomStock
    },
    getChildTypeName(childrenType) {
      switch(childrenType) {
      case 'a':
      case '10':
      case 'childrenType10':
        return CHILDREN_TYPE.A
      case 'b':
      case '15':
      case 'childrenType15':
        return CHILDREN_TYPE.B
      case 'c':
      case '20':
      case 'childrenType20':
        return CHILDREN_TYPE.C
      case 'd':
      case '30':
      case 'childrenType30':
        return CHILDREN_TYPE.D
      case 'e':
      case '40':
      case 'childrenType40':
        return CHILDREN_TYPE.E
      case 'f':
      case '50':
      case 'childrenType50':
        return CHILDREN_TYPE.F
      default:
        return ''
      }
    }
  }
}